import { render, staticRenderFns } from "./ArquivoRetorno.vue?vue&type=template&id=22ca6ffc&"
import script from "./ArquivoRetorno.vue?vue&type=script&lang=js&"
export * from "./ArquivoRetorno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports